<template>
  <div class="d-flex flex-column h-100" id="#app">
    <header>
      <nav class="navbar navbar-expand-sm navbar-dark fixed-top bg-dark justify-content-end">
        <router-link :to="{ name: 'MainIndex' }" class="navbar-brand">TheMediaDB</router-link>

          <div class="ml-auto mr-1 collapse navbar-collapse flex-grow-0">
          <ul class="navbar-nav text-left">
            <li class="nav-item">
              <router-link :to="{ name: 'MoviesIndex' }" class="nav-link">Movies</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'MusicIndex' }" class="nav-link">Music</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'ShowIndex' }" class="nav-link">Shows</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'OrganizationsIndex' }" class="nav-link">Organizations</router-link>
            </li>
            <li class="nav-item">
              <router-link :to="{ name: 'UsersIndex' }" class="nav-link">Users</router-link>
            </li>
          </ul>
          <ul class="navbar-nav text-right">
            <li class="nav-item" v-if="!signedIn()">
              <router-link :to="{ name: 'Login' }" class="nav-link">Login</router-link>
            </li>
            <li class="nav-item" v-if="signedIn()">
              <a href="" @click="logout" class="nav-link">Logout</a>
            </li>
          </ul>
        </div>
      </nav>
    </header>

    <main role="main">
      <div class="container">
        <notifications style="top: 4rem"/>
        <router-view/>
      </div>
    </main>

    <footer class="footer bg-dark mt-auto py-3">
      <div class="container">
        <span class="text-muted">TheMediaDB</span>
      </div>
    </footer>

    <vue-progress-bar/>
  </div>
</template>

<script>

import AuthenticationService from '@/common/services/authentication.service';
import JwtService from '@/common/services/jwt.service';


export default {
  data() {
    return {
      jwt: null,
    }
  },
  created() {
    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }
      //  start the progress bar
      this.$Progress.start();
      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach((to, from) => {
      //  finish the progress bar
      this.$Progress.finish();
    });

    this.jwt = JwtService.parseJwt();
  },
  methods: {
    logout() {
      AuthenticationService.logout();
    },
    signedIn() {
      return JwtService.parseJwt() !== null;
    },
  },
};
</script>

<style lang="scss">
body {
  padding-top: 5rem;
  height: 100vh;
}
</style>
